import Image from "next/image";
import Link from "next/link";
import { FaInstagram } from "react-icons/fa";
import { MdFacebook } from "react-icons/md";

import AmericanExpress from "public/images/paymentMethods/american-express.svg";
import Barcode from "public/images/paymentMethods/barcode.png";
import Diners from "public/images/paymentMethods/diners.svg";
import Elo from "public/images/paymentMethods/elo.svg";
import Hipercard from "public/images/paymentMethods/hipercard.svg";
import Master from "public/images/paymentMethods/mastercard.svg";
import Pix from "public/images/paymentMethods/pix.png";
import Visa from "public/images/paymentMethods/visa.svg";
import remixImage from "public/images/remix.png";

import type { JSX, ReactNode } from "react";

interface UrlItem {
  name?: string;
  href?: string;
  openInNewTab?: boolean;
  customContent?: ReactNode;
}

export const Footer = (): JSX.Element => {
  const urlGroups: Array<{ name: string; urls: UrlItem[] }> = [
    {
      name: "Sobre o Remix",
      urls: [
        {
          name: "O que fazemos",
          href: "/associacao",
        },
        {
          customContent: (
            <div className="flex gap-2">
              {/**Não existe temos facebook por enquanto, enquanto isso manteremos esse link */}
              <Link href="https://www.facebook.com/useremix/" target="_blank" rel="noopener noreferrer">
                <MdFacebook size="2.5rem" className="text-base-black" />
              </Link>

              <Link href="https://www.instagram.com/remixondemand/" target="_blank" rel="noopener noreferrer">
                <FaInstagram size="2.5rem" className="text-base-black" />
              </Link>
            </div>
          ),
        },
      ],
    },
    {
      name: "O que posso fazer?",
      urls: [
        {
          name: "Customizar modelo",
          href: "/customizar-produto/passo-1",
        },
        {
          name: "Descobrir produtos",
          href: "/busca?public=FEMININO&public=MASCULINO&public=INFANTIL",
        },
        {
          name: "Criar uma loja",
          href: "/criar-loja",
        },
      ],
    },
    {
      name: "Minha conta",
      urls: [
        {
          name: "Meus desejos",
          href: "/meus-desejos",
        },
        {
          name: "Meus pedidos",
          href: "/meus-pedidos",
        },
      ],
    },
    {
      name: "Suporte",
      urls: [
        {
          name: "Políticas de privacidade",
          href: "/docs/privacy-policy.pdf",
          openInNewTab: true,
        },
        {
          name: "Termos de uso",
          href: "docs/terms.pdf",
          openInNewTab: true,
        },
        {
          name: "Perguntas frequentes",
          href: "/perguntas-frequentes",
        },
        {
          name: "Status do seu pedido",
          href: "/meus-pedidos",
        },
        {
          name: "Fale conosco",
          href: "mailto:atendimento@useremix.com.br",
        },
      ],
    },
  ];

  const paymentMethodImages = [
    { name: "American Express", image: AmericanExpress },
    { name: "Boleto", image: Barcode },
    { name: "Diners", image: Diners },
    { name: "Elo", image: Elo },
    { name: "Hipercard", image: Hipercard },
    { name: "Mastercard", image: Master },
    { name: "Pix", image: Pix },
    { name: "Visa", image: Visa },
  ];

  return (
    <div
      className={
        "mt-auto flex flex-col items-center bg-base-input bg-[-82px_100%] p-page-x-margin py-3 " +
        "bg-no-repeat lg:bg-[length:578px_502px] lg:bg-[-29px_0] lg:pb-[6.25rem] lg:pt-[2.75rem]"
      }
      style={{ backgroundImage: "url(/images/white-remix-background.svg)" }}
    >
      <div
        className={
          "flex max-w-[var(--page-max-width)] items-start max-lg:flex-col max-lg:gap-5 max-lg:items-center max-lg:w-full " +
          "lg:w-full lg:justify-between"
        }
      >
        <Image src={remixImage} alt="" className="h-4 w-auto" sizes="226px" />

        {urlGroups.map((urlGroup) => (
          <div key={urlGroup.name} className="flex flex-col gap-2 max-lg:items-center">
            <p className="font-bold text-brand-primary">{urlGroup.name}</p>

            <div className="h-[1px] w-full bg-base-white" />

            {urlGroup.urls.map((url, urlIndex) => [
              url.href ? (
                <Link
                  key={`link-${urlIndex}`}
                  href={url.href}
                  {...(url.openInNewTab && { target: "_blank", rel: "noopener noreferrer" })}
                >
                  {url.name}
                </Link>
              ) : (
                <div key={`custom-${urlIndex}`}>{url.customContent}</div>
              ),
              urlIndex < urlGroup.urls.length - 1 && (
                <div key={`separator-${urlIndex}`} className="h-[1px] w-full bg-base-white" />
              ),
            ])}
          </div>
        ))}

        <div>
          <p className="font-bold text-brand-primary">Formas de pagamento</p>

          <div className="my-2 h-[1px] w-full bg-base-white" />

          <div className="flex max-w-[11.25rem] flex-wrap gap-2">
            {paymentMethodImages.map((image) => (
              <Image
                key={image.name}
                src={image.image}
                alt={image.name}
                className="h-auto min-w-[40px]"
                height={24}
                width={40}
                sizes="40px"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
